import React, { useState, useEffect, useCallback, useRef, createRef } from 'react';
import { icons, FLAVOR } from "../../helpers/constants";
import { useTranslation } from "react-i18next";
import * as request from "../../services/FetchService";
import AccountModal from '../Modals/AccountModal';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import SafetyRow from '../Safety/SafetyRow';
import SafetyRowPlaceholder from '../Safety/SafetyRowPlaceholder';
import NewButton from '../Buttons/NewButton';
import { useIsMobile } from '../../helpers/customHooks';
import { useSidebarContext } from '../Sidebar/SiderbarContext';
import SecurityView from './SecurityView';

const Account = ({ isOpen, setOuterType, outerType, setIsOpen }) => {
	const { t } = useTranslation();
    const MOBILE = useIsMobile();
    const [accountInfo, setAccountInfo] = useState()
    const [showModal, setShowModal] = useState(false)
    const [type, setType] = useState()
    const [showSecurity, setShowSecurity] = useState(false)
    const { setActionbarContent, setTopbarContent } = useSidebarContext();
    
    const navigate = useNavigate();

    useEffect(() => {
        getAccountInfo()
    }, [])

    const getAccountInfo = () => {
        request.get("account/info").then((response) => {
            let data = response.data.response
            setAccountInfo(data)
        })
        
    }

    const openModal = (type) => {
        setType(type)
        setShowModal(!showModal)
    }

    const saveData = (data) => {
        if(data instanceof File){
            request.put("account/picture/upload", data).then((response) => {
                if(response.data.successful){
                    let imgurl = response.data.imageurl
                    let data2 = { imageurl: imgurl }
                    request.post("", "account/update", data2).then((response2) => {
                        if(response2.data.successful){
                            setShowModal(!showModal)
                            getAccountInfo()
                            toast.success(t("toast.saved"));
                        }else{
                            toast.error(t("toast.failed"));
                        }
            
                    })
                }
            })
            return
        }
        request.post("", "account/update", data).then((response) => {
            if(response.data.successful){
                setShowModal(!showModal)
                getAccountInfo()
                toast.success(t("toast.saved"));
            }else{
                toast.error(t("toast.failed"));
            }

        })
    }

    const deleteAccount = () => {
        const userid = accountInfo.userid
        request.post("", "account/delete", {userid: userid}).then((response) => {
            if(response.data.error){
                toast.error(response.data.api_message)
            }else{
                localStorage.clear()
                navigate("/devices")
            }

        })
    }

    const items = [
        {
            key: "username",
            label: t("settings.name"),
            value: accountInfo?.username ?? "",
            icon: icons.dots_vertical,
            function: openModal
        },
        {
            key: "email",
            label: t("settings.email"),
            value: accountInfo?.email ?? "",
            icon: icons.dots_vertical,
            function: openModal
        },
        {
            key: "password",
            label: t("settings.password"),
            value: "••••••••••••",
            icon: icons.dots_vertical,
            function: openModal
        },
        {
            key: "security",
            label: t("settings.account_security"),
            // value: "••••••••••••",
            icon: icons.chevron_right,
            function: () => setOuterType("security")
            
        },
        {
            key: "delete",
            label: t("settings.delete_account"),
            value: "",
            icon: icons.chevron_right,
            destructive: true,
            function: openModal
        }
    ]
    const listView = () => {
        if(showSecurity) return;
        return(
        <>
            {/* <p className="mb-1 bold">{t("settings.my_account")}</p> */}
            {/* {FLAVOR === "bike" &&
            <div className="userimage mx-auto position-relative mb-3">
                <img src={accountInfo?.userimage ?? null} alt="" className="w-100" />
                <div className="editimg position-absolute bottom-0 end-0 d-flex justify-content-center align-items-center mb-2 cursor-pointer" onClick={() => openModal("img")} >
                    <img className="white-icon" src={icons.pen} alt=""/>
                </div>
            </div>
            } */}
            <div className="d-flex flex-column settings-radius">
                {items.map((item, index) =>(
                    <div 
                        onClick={() => item.function(item.key)}
                        key={index} 
                        className={`cursor-pointer p-3 d-flex justify-content-between bg-white ${index < items.length-1 ? "border-settings" : ""}`}>
                            <span className={`body primary ${item.destructive ? "red" : ""}`}>{item.label}</span>
                        <div className="d-flex align-items-center">
                            <p className="bold">{item?.value}</p>
                            <img className="ms-3 size_15 grey-blue-icon" src={item.icon} alt={""} />
                        </div>
                    </div>
                ))}
            </div>
        </>
        )
    }

    useEffect(() => {
        if(!isOpen){
            setShowSecurity(false)
        }
    }, [isOpen])

    useEffect(() => {
        if(outerType === "security"){
            setShowSecurity(true)
        }else{
            setShowSecurity(false)
        }
    }, [outerType])

    // useEffect(() => {
    //     if(showSecurity){
    //         setOuterType("security")
    //     }else{
    //         setOuterType(null)
    //     }
    // }, [showSecurity])



    return(
        <>
        {listView()}
        {<SecurityView show={showSecurity} />}
        <AccountModal show={showModal} type={type} data={accountInfo} deleteAccount={() => deleteAccount()} onSave={(data) => saveData(data)} onClose={() => setShowModal(!showModal)} />
        </>
    )
}

export default Account;